import { Phone, Mail, ArrowUpRight, MapPin } from "lucide-react";
import { Logo } from "./Logo";
import { CONTACT, NAV, SUPPLIERS } from "../../lib/data";
import { scrollToId } from "../../lib/scroll";

export const Footer = () => {
  const go = (href) => scrollToId(href);

  return (
    <footer className="bg-ink text-white pt-20 pb-10" data-testid="site-footer">
      <div className="max-w-[1600px] mx-auto px-5 sm:px-8">
        {/* Giant phone */}
        <a
          href={`tel:+47${CONTACT.phoneRaw}`}
          data-testid="footer-phone"
          className="flex items-center gap-[0.12em] font-oswald font-bold uppercase tracking-tighter leading-none text-[19vw] lg:text-[13vw] hover:text-redx transition-colors duration-300"
        >
          <Phone className="w-[0.7em] h-[0.7em] shrink-0" strokeWidth={1.5} /> {CONTACT.phone}
        </a>

        <div className="grid grid-cols-12 gap-8 mt-16 pt-12 border-t border-white/10">
          <div className="col-span-12 md:col-span-4">
            <Logo dark className="h-12" />
            <p className="text-white/50 mt-5 max-w-xs leading-relaxed">
              Utstyr og service til storkjøkken, vaskeri, skyllerom og institusjon i hele Midt-Norge.
            </p>
          </div>

          <div className="col-span-6 md:col-span-2">
            <h4 className="font-oswald uppercase text-xs tracking-widest text-redx mb-4">Navigasjon</h4>
            <ul className="space-y-2">
              {NAV.map((n) => (
                <li key={n.href}>
                  <button onClick={() => go(n.href)} data-testid={`footer-nav-${n.href.replace("#", "")}`} className="text-white/70 hover:text-white transition-colors">
                    {n.label}
                  </button>
                </li>
              ))}
              <li>
                <a
                  href={CONTACT.customerPortal}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="footer-kundeportal"
                  className="inline-flex items-center gap-1 text-redx hover:text-white font-medium transition-colors"
                >
                  Kundeportal <ArrowUpRight size={13} />
                </a>
              </li>
            </ul>
          </div>

          <div className="col-span-6 md:col-span-3">
            <h4 className="font-oswald uppercase text-xs tracking-widest text-redx mb-4">Leverandører</h4>
            <ul className="space-y-2">
              {SUPPLIERS.map((s, i) => (
                <li key={s.name}>
                  <a href={s.url} target="_blank" rel="noopener noreferrer" data-testid={`footer-supplier-${i}`} className="text-white/70 hover:text-white transition-colors inline-flex items-center gap-1">
                    {s.name} <ArrowUpRight size={13} />
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="col-span-12 md:col-span-3">
            <h4 className="font-oswald uppercase text-xs tracking-widest text-redx mb-4">Kontakt</h4>
            <ul className="space-y-3">
              <li><a href={`tel:+47${CONTACT.phoneRaw}`} className="flex items-center gap-2 text-white/70 hover:text-white transition-colors"><Phone size={15} /> {CONTACT.phone}</a></li>
              <li><a href={`mailto:${CONTACT.sales}`} className="flex items-center gap-2 text-white/70 hover:text-white transition-colors break-all"><Mail size={15} /> {CONTACT.sales}</a></li>
              <li><a href={`mailto:${CONTACT.service}`} className="flex items-center gap-2 text-white/70 hover:text-white transition-colors break-all"><Mail size={15} /> {CONTACT.service}</a></li>
              <li className="flex items-start gap-2 text-white/70 pt-1" data-testid="footer-address"><MapPin size={15} className="mt-0.5 shrink-0" /> <span>{CONTACT.address}</span></li>
            </ul>
          </div>
        </div>

        <div className="flex flex-col sm:flex-row justify-between gap-4 mt-14 pt-6 border-t border-white/10 text-white/40 text-sm">
          <span>© {new Date().getFullYear()} Trøndelag Storkjøkkensenter AS</span>
          <span className="font-oswald uppercase tracking-widest">Electrolux Professional Sertifisert Partner</span>
        </div>
      </div>
    </footer>
  );
};
